<template>
  <div class="flex-col">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.flex-col {
  max-width: 100%;
  width: 100%;

  @include breakpoint('md') {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
}
</style>
